import { StatusData } from "@fairfleet/geotab";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid-pro";
import { DiagnosticCell } from "@/components/grid/cells/DiagnosticCell";
import { RenderHeader } from "@/components/grid/cells/RenderHeader";
import { usePresetContext } from "@/components/PresetProvider";
import { PageType } from "@/constants/PageType";
import { DeviceStatusOverviewData } from "@/models/DeviceStatusOverviewData";

export const usePresetColumns = (pageType?: PageType) => {
  const { selectedPreset } = usePresetContext(pageType);
  const columns: GridColDef[] =
    selectedPreset?.columns?.map(col => {
      const dId = col.diagnostic.id;
      return {
        minWidth: 10,
        width: 150,
        field: dId,
        renderHeader: RenderHeader,
        headerName: col.diagnostic.name,
        type: "number",
        renderCell: (props: GridRenderCellParams) => <DiagnosticCell props={props} />,
        valueGetter: (_, row: DeviceStatusOverviewData) =>
          ((row.statusData?.statusData ?? []) as unknown as StatusData[])?.find(
            sd => sd.diagnostic.id === dId,
          )?.data ?? 0,
      } as GridColDef;
    }) ?? [];
  return { columns };
};
